module.exports = __webpack_public_path__ + "img/848d29c.png";